import React from 'react'

export default function (){

    return(
        <div className="constainer-fluid">
            <svg style={{position: 'absolute', zIndex: '-10'}} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 250">
                <path fill="#3f51b5" fillOpacity="1" d="M0,64L60,80C120,96,240,128,360,128C480,128,600,96,720,90.7C840,85,960,107,1080,133.3C1200,160,1320,192,1380,208L1440,224L1440,0L1380,0C1320,0,1200,0,1080,0C960,0,840,0,720,0C600,0,480,0,360,0C240,0,120,0,60,0L0,0Z"></path>
            </svg>  
        </div>
    )
}